import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, ControlLabel, Form, FormGroup, Panel} from 'react-bootstrap';
import {Field, reduxForm} from 'redux-form';
import Slider from './Slider';
import {InputField} from './InputField';
import {Link} from 'react-router-dom'
import {validation} from '../validation';
import {NUM_AMPLITUDES, NUM_SPREADS} from '../Constants';
import Confirmation from './Confirmation';
import values from 'lodash/values';
import keyBy from 'lodash/keyBy';
import {SelectField} from './SelectField';
import classNames from 'classnames';

const AmplitudeSlider = ({input: {value, onChange, onBlur}}) => {
    value = value ? parseInt(value, 10) : 0;
    return (
        <FormGroup style={{marginBottom: 40}}>
            <Col md={3} componentClass={ControlLabel}>{'Amplitude'}</Col>
            <Col md={9} style={{marginTop: -12}}>
                <Slider
                    value={value}
                    min={1}
                    max={NUM_AMPLITUDES}
                    rangeMarks={{step: 1}}
                    onChange={onChange}
                />
            </Col>
        </FormGroup>
    );
};

const SpreadSlider = ({input: {value, onChange, onBlur}}) => {
    value = value ? parseInt(value, 10) : 0;
    return (
        <FormGroup style={{marginBottom: 40}}>
            <Col md={3} componentClass={ControlLabel}>{'Spread'}</Col>
            <Col md={9} style={{marginTop: -12}}>
                <Slider
                    dots={true}
                    value={value}
                    min={1}
                    max={NUM_SPREADS}
                    rangeMarks={{step: 1}}
                    onChange={onChange}
                />
            </Col>
        </FormGroup>
    );
};

const validate = validation({
    name: {
        required: true,
    },
    amplitude: {
        customValidator: (value) => {
            if (value < 1 || value > NUM_AMPLITUDES) {
                return 'Invalid spread value';
            }
            return null;
        }
    },
    spread: {
        customValidator: (value) => {
            if (value < 1 || value > NUM_SPREADS) {
                return 'Invalid spread value';
            }
            return null;
        }
    }
});

@reduxForm({form: 'PresetEdit', validate})
export default class PresetEdit extends Component {
    static propTypes = {
        presetId: PropTypes.number,
        usageLimitEditable: PropTypes.bool,
        initialValues: PropTypes.object, // this contains the actual data for this entity
        handleSubmit: PropTypes.func, // passed by redux-form
        onDeletePreset: PropTypes.func,
        history: PropTypes.object,
        header: PropTypes.object,
        presets: PropTypes.object,
    };

    handleDelete = () => {
        this.props.onDeletePreset(this.props.presetId);
        this.props.history.push('/presets');
    };

    presetNumberOptions = () => {
        const {presets, presetId} = this.props;
        const presetsByNumber = keyBy(values(presets), 'presetNumber');
        const options = [];
        options.push({
            label: <span className="unassigned">{'none'}</span>,
            value: '',
            renderedValue: 'none',
        });
        for (let i = 1; i <= 9; ++i) {
            const iPreset = presetsByNumber[i];
            let label;
            if (iPreset) {
                label = (
                    <span
                        className={classNames('assigned', {current: presetId === iPreset.id})}
                    >
                        {`${i} - assigned to "${iPreset.name}" (a: ${iPreset.amplitude}, s: ${iPreset.spread})`}
                    </span>
                );
            } else {
                label = <span className="unassigned">{`${i} - unassigned`}</span>;
            }
            options.push({
                label,
                value: i,
                renderedValue: i,
            });
        }
        return options;
    };

    render() {
        const {presetId, history, handleSubmit} = this.props;
        const header = this.props.header || (
            <div className="edit-header">
                <ol className="breadcrumb">
                    <li><Link to="/presets">{'Presets'}</Link></li>
                    <li className="active">{presetId ? `Update #${presetId}` : 'Create New'}</li>
                </ol>
                <div className="pull-right">
                    {presetId &&
                    <Confirmation
                        name={`deleteConformationModal-${presetId}`}
                        bsStyle="danger"
                        bsSize="small"
                        onConfirm={this.handleDelete}
                        componentLabel={<span><i className="fa fa-remove"/>{' Delete'}</span>}
                    >
                        {'Delete preset?'}
                    </Confirmation>
                    }
                </div>
            </div>
        );

        return (
            <Panel header={header}>
                <Form onSubmit={handleSubmit} style={{margin: 'auto', width: 600}} horizontal className="preset-edit">
                    <Field type="text" name="name" component={InputField} label="Name" required autoFocus/>
                    <Field type="text" name="amplitude" component={AmplitudeSlider} label="Amplitude"/>
                    <Field type="text" name="spread" component={SpreadSlider} label="Spread"/>
                    <Field type="text" name="presetNumber" component={SelectField} label="Number" options={this.presetNumberOptions()} className="preset-number"/>
                    <FormGroup>
                        <Col mdOffset={3} md={9}>
                            <Button type="submit" bsStyle="success">{presetId ? 'Update' : 'Create'}</Button>
                            <Button bsStyle="link" title="Cancel and go back" onClick={() => history.goBack()}>{'Cancel'}</Button>
                        </Col>
                    </FormGroup>
                </Form>
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PresetEdit.js